module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--two-cube",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b26aa61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/TwoCube.vue
// module id = 672
// module chunks = 0